"use client"
import React, {useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import styled from 'styled-components';
import reactHtmlParser from 'react-html-parser';
import SelectField from "@/components/common/SelectField";
import Link from "next/link";
// import {apiEndPoints} from '../../api/network/apiEndPoints';
// import {ApiParam} from '../../api/network/apiParams';
// import {fetchPostsChild} from '../../api/redux/university';
import {hardGray, hover, softWhite, text, white} from "@/styles/globalStyleVars";
import {getSchools} from "@/api";

/**
 * Overview Type 6 component section
 * Pass the props with your data to the Overview Type 6 component.
 * Check the page folder to see the components used.
 **/
const CollegeList = ({data, id, offset}) => {


    const dispath = null;
    const [selectedData, setSelectedData] = useState(data?.data);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [disableCourse, setDisableCourse] = useState(true);


    let countryArray = data?.filter?.country
    let studyArray = data?.filter?.area

    let countryOptions = [];
    let studyOptions = [];


    // Check if universityArray is defined and not empty
    if (countryArray && countryArray.length > 0) {
        countryOptions = countryArray.map(e => ({
            value: e?.category_data?.id,
            label: reactHtmlParser(e?.category_data?.title)
        }));
    }

    // Check if universityArray is defined and not empty
    if (studyArray && studyArray.length > 0) {
        studyOptions = studyArray
            .filter(e => e?.category_data?.list?.[0]?.category_data?.id && e?.category_data?.list?.[0]?.category_data?.title)
            .map(e => ({
                value: e.category_data.list[0].category_data.id,
                label: reactHtmlParser(e.category_data.list[0].category_data.title)
            }));
    }





    const handleClickCountry = async (country ) => {
        try {
            const getHomeData = await getSchools(country?.value,'');
            setSelectedData(getHomeData?.data)
            setDisableCourse(false);
            setSelectedCountry(country?.value)
        } catch (error) {

        }
    };



    const handleClickStudy = async (country ) => {
        try {
            const getHomeData = await getSchools(selectedCountry,country?.value);
            setSelectedData(getHomeData?.data)

        } catch (error) {

        }

    };


    const options = [
        {value: '', label: 'All'}
    ];


    const mergedOptions = options.concat(countryOptions?.map(item => ({
        value: item.value,
        label: item.label
    })));


    return (
        <StyledOverview6 id={id} offset={offset} className={'ministry '}>
            <Container>
                <Row className={'filter-wrapper'}>
                    <Col md={4} className={'filter'}>
                        <SelectField selection={mergedOptions}  onChange={handleClickCountry} background={'transparent'} color={'#888888'} border={'#888888'} placeholder={'Country'}/>
                    </Col>
                    <Col md={4} className={'filter'}>
                        <SelectField selection={studyOptions}  background={'transparent'} color={'#888888'} border={'#888888'} placeholder={'Area'} disabled={disableCourse ? true : false} onChange={handleClickStudy}/>
                    </Col>
                    <Col md={4} className={'filter'}>

                    </Col>
                </Row>
                <Row className={'versity-list-row'}>


                    {
                        selectedData && selectedData?.length > 0 ?
                            selectedData?.map((e, index) => {
                                const thumb = e?.images?.list?.find((f) => f?.thumb === 'on')

                                return (

                                    <Col key={index}>
                                        <div className="image-wrapper">
                                            <Link prefetch={true}  href={`schools/${e?.data?.slug}`}></Link>

                                            <img height={58}  src={thumb?.full_path} alt={reactHtmlParser(e?.data?.title)}/>
                                            <p className={''}>{reactHtmlParser(e?.data?.title)}</p>
                                        </div>
                                    </Col>

                                );
                            }) :

                            <Col md={12}>
                                <h4>No School Found</h4>
                            </Col>
                    }



                </Row>
            </Container>
        </StyledOverview6>
    );
};

/**
 * Styled component for Overview Type 6 component section
 * Add your custom styles for this component
 **/
const StyledOverview6 = styled.section`
    position: relative;
    padding-top: 80px;
    padding-bottom: 200px;
    background: ${softWhite};

    h2 {
        margin-bottom: 40px;

        span {
            color: ${hover}
        }
    }


    .filter-wrapper {
        padding-bottom: 60px;

        .filter--is-disabled {
            .filter__control {
                border: 1px solid transparent;

            }

            .filter__placeholder {
                color: ${hardGray};
            }

            .filter__indicator svg line {
                stroke: rgb(4, 5, 4) !important;
            }
        }

        .filter__control {
            border: 1px solid ${hardGray};
            max-width: 100%;
            background: ${white};
        }

        .filter__placeholder {
            color: ${text};
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
        }

        .filter__single-value {
            font-size: 16px;
            line-height: 24px;
            letter-spacing: -0.16px;
            font-weight: 400;
            color: ${text};

        }


        @media (max-width: 992px) {
            .col-md-4.filter {
                margin-bottom: 30px;
                flex: 0 0 100%;
                max-width: 100%;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .versity-list-row {
        display: flex;
        flex-wrap: wrap;
        margin: -15px; /* Adjust for negative margins */

        .col {
            flex: 0 0 calc(16.666% - 30px); /* 16.666% to accommodate the gap */
            max-width: calc(16.666% - 30px); /* 16.666% to accommodate the gap */
            margin: 15px; /* Adjust for negative margins */
            padding-left: 0;
            padding-right: 0;

            .image-wrapper {
                background: ${softWhite};
                padding: 45px 15px;
                position: relative;
                border: 1px solid rgba(54, 50, 49, 0.1);
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;

                a {
                    position: absolute;
                    inset: 0;
                    z-index: 1;
                }

                img {
                    transition: 0.7s all ease;
                    position: relative;
                }

                p {
                    position: absolute;
                    transform: translateY(50px);
                    transition: 0.7s all ease;
                    opacity: 0;
                    visibility: hidden;
                    text-align: center;
                    padding: 0 15px;
                    font-size: 12px;
                    line-height: 16px;
                    letter-spacing: -0.2px;
                    color: ${hardGray};
                    font-weight: 600;
                }

                &:hover {
                    p {
                        transform: translateY(0);
                        opacity: 1;
                        visibility: visible;

                    }

                    img {
                        transform: translateY(50px);
                        opacity: 0;
                        visibility: hidden;

                    }
                }
            }

            @media (max-width: 992px) and (min-width: 768px) {
                flex: 0 0 calc(33.333333333% - 30px); /* 16.666% to accommodate the gap */
                max-width: calc(33.333333333% - 30px); /* 16.666% to accommodate the gap */


            }
            @media (max-width: 767px) {
                flex: 0 0 calc(50% - 30px); /* 16.666% to accommodate the gap */
                max-width: calc(50% - 30px); /* 16.666% to accommodate the gap */


            }
        }
    }

`;

export default React.memo(CollegeList);
